import { render, staticRenderFns } from "./RetrieveThePassword.vue?vue&type=template&id=03d85731&scoped=true"
import script from "./RetrieveThePassword.vue?vue&type=script&lang=js"
export * from "./RetrieveThePassword.vue?vue&type=script&lang=js"
import style0 from "./RetrieveThePassword.vue?vue&type=style&index=0&id=03d85731&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d85731",
  null
  
)

export default component.exports